module.exports = __webpack_public_path__ + "img/fig36.ee2a70fb.jpg";